import { bindActionCreators } from "@reduxjs/toolkit";
import * as React from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../../../store";
import DialogBase from "../DialogBase";
import * as DialogStore from "../DialogStore";
import Texts from "../../../resources/Texts";
import { Box } from "@mui/material";
import FailedLoginDialogContent from "./FailedLoginDialogContent";

type FailedLoginDialogProps = DialogStore.DialogState & typeof DialogStore.actionCreators & {};

const FailedLoginDialog: React.FC<FailedLoginDialogProps> = ({
	failedLoginDialog,
	setFailedLoginDialogState,
}) => {
	const handleClose = (): void => {
		setFailedLoginDialogState({
			errorMessage: null,
			open: false,
		});
	};

	if (!failedLoginDialog) {
		return null;
	}

	return (
		<DialogBase
			open={failedLoginDialog.open}
			dialogTitle={
				<Box
					component="span"
					sx={{
						fontWeight: "600",
					}}
				>
					{Texts.Dialogs.FailedLoginDialog.Title}
				</Box>
			}
			primaryButtonText={Texts.Dialogs.Actions.Ok}
			topBorderColor="#FF3333"
			onCancel={handleClose}
			onSubmit={handleClose}
		>
			<FailedLoginDialogContent errorMessage={failedLoginDialog.errorMessage} />
		</DialogBase>
	);
};

const mapStateToProps = (state: ApplicationState) => {
	return state.dialogs;
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...DialogStore.actionCreators,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(FailedLoginDialog);
